export const shouldUseCabelasBranding = (mainWindow = globalThis?.window) => {
	return !!mainWindow?.location && mainWindow.location?.origin.includes('cabelas-shield');
};
